export const enum OverlayType {
    DropFiles = 'DropFiles',
    CoinGame = 'CoinGame',
    Calendar = 'Calendar',
    DatePicker = 'DatePicker',
    ColorSchemePicker = 'ColorSchemePicker',
    HistoryDumpDialog = 'HistoryDumpDialog',
    OperationDetails = 'OperationDetails',
}
